import NavigatorPosition from "../models/navigatorPosition";
import ProjectSettings from "../models/projectSettings";
import Settings from "../models/settings";
import httpService from "./httpService";

const apiEndpoint = "/settings";

const getSettings = async (defaultSettings: Settings): Promise<Settings> => {
  const { data: settings } = await httpService.post<Settings>(
    `${apiEndpoint}/getSettings`,
    defaultSettings,
  );
  if (settings) {
    Object.setPrototypeOf(settings, Settings.prototype);

    settings.init();
  }

  return Promise.resolve(settings);
};

const saveSettings = (settings: Settings) => {
  return httpService.post(`${apiEndpoint}/saveSettings`, settings);
};

const getProjectSettings = async (idProject: number) => {
  return httpService.get<ProjectSettings>(
    `${apiEndpoint}/getProjectSettings?idProject=${idProject}`,
  );
};

const saveLocation = (
  idProject: number,
  navigatorPosition: NavigatorPosition,
) => {
  return httpService.post(`${apiEndpoint}/saveLocation`, {
    idProject,
    navigatorPosition,
  });
};

const settingService = {
  getSettings,
  saveSettings,
  getProjectSettings,
  saveLocation,
};

export default settingService;
